import cx from "classnames"
import type { ReactNode } from "react"
import type { breakpoints } from "../../../tokens"

export type ResponsiveProp<T> = {
  [key in keyof typeof breakpoints]?: T
}

type DirectionProp = "row" | "column" | "row-reverse" | "column-reverse"
type ResponsiveDirection = ResponsiveProp<DirectionProp>

const getDirectionClasses = (
  direction: ResponsiveDirection | DirectionProp,
) => {
  const directionClasses: string[] = []
  if (typeof direction === "string") {
    directionClasses.push(`c-flex-${direction}`.replace("column", "col"))
  } else {
    for (const [key, value] of Object.entries(direction)) {
      directionClasses.push(`${key}:c-flex-${value}`.replace("column", "col"))
    }
  }
  return directionClasses
}

export const Flexible = ({
  children,
  direction = "column",
  bottomPadding = false,
  isFullHeight = false,
}: {
  children?: ReactNode
  direction?: ResponsiveDirection | DirectionProp
  bottomPadding?: boolean
  isFullHeight?: boolean
}) => {
  return (
    <div
      className={cx("cobalt-layout-flexible", getDirectionClasses(direction), {
        "cobalt-layout--bottomPadding": bottomPadding,
        "cobalt-layout--fullHeight": isFullHeight,
      })}
    >
      {children}
    </div>
  )
}

export const FlexibleWithConstraint = ({
  children,
  size,
  direction = "column",
  bottomPadding = false,
  isFullHeight = false,
}: {
  children?: ReactNode
  size: "small" | "medium" | "large"
  direction?: ResponsiveDirection | DirectionProp
  bottomPadding?: boolean
  isFullHeight?: boolean
}) => {
  return (
    <div
      className={cx(
        `cobalt-layout-flexibleWithConstraint cobalt-layout-flexibleWithConstraint--${size}`,
        getDirectionClasses(direction),
        {
          "cobalt-layout--bottomPadding": bottomPadding,
          "cobalt-layout--fullHeight": isFullHeight,
        },
      )}
    >
      {children}
    </div>
  )
}

export const Fixed = ({
  children,
  width,
  direction = "column",
  bottomPadding = false,
  isFullHeight = false,
}: {
  children?: ReactNode
  width: 280 | 420 | 600
  direction?: ResponsiveDirection | DirectionProp
  bottomPadding?: boolean
  isFullHeight?: boolean
}) => {
  return (
    <div
      className={cx(
        `cobalt-layout-fixed cobalt-layout-fixed--${width}`,
        getDirectionClasses(direction),
        {
          "cobalt-layout--bottomPadding": bottomPadding,
          "cobalt-layout--fullHeight": isFullHeight,
        },
      )}
    >
      {children}
    </div>
  )
}
